module.exports = __webpack_public_path__ + "img/图标统计.8cdf5fb5.png";